module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8627/img/pumpkin.svg"